export const SET_EMPLOYEE_LIST = "SET_EMPLOYEE_LIST";

export const SET_EMPLOYEE_GET_BY_ID = "SET_EMPLOYEE_GET_BY_ID";

export const SET_IS_EMPLOYEE_TABLE_LOADING = "IS_EMPLOYEE_TABLE_LOADING";

export const SET_ALL_ROLES = "SET_ALL_ROLES";
